"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.COMPONENT_NAME = exports.getIconSize = exports.COLOR_THEME = exports.THEME = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));

require("./Input.scss");

var _gerenciatdUtils = require("@bit/gerenciatd.utils.metrics");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var THEME = {
  LINE: 'line',
  ROUNDED: 'rounded',
  BOX: 'box'
};
exports.THEME = THEME;
var COLOR_THEME = {
  WHITE: 'white'
};
exports.COLOR_THEME = COLOR_THEME;

var getIconSize = function getIconSize(inputType) {
  switch (inputType) {
    case THEME.LINE:
      return 24;

    case THEME.ROUNDED:
      return 20;

    default:
      return 24;
  }
};

exports.getIconSize = getIconSize;
var COMPONENT_NAME = 'Input';
exports.COMPONENT_NAME = COMPONENT_NAME;

var Input = /*#__PURE__*/function (_Component) {
  _inherits(Input, _Component);

  var _super = _createSuper(Input);

  function Input(props) {
    var _this;

    _classCallCheck(this, Input);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "setCsscolorTheme", function (colorTheme) {
      return "e-input--theme-".concat(colorTheme);
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (evt) {
      var onChange = _this.props.onChange;
      var currentTarget = evt.currentTarget;
      var value = currentTarget.value;

      _this.setState({
        content: value
      });

      if (onChange) {
        onChange(value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "cleanInput", function () {
      var cleanAction = _this.props.cleanAction;

      if (cleanAction) {
        cleanAction();
      }

      _this.setState({
        content: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnFocus", function () {
      var _this$props = _this.props,
          _this$props$taggingIn = _this$props.taggingInfo,
          taggingInfo = _this$props$taggingIn === void 0 ? {} : _this$props$taggingIn,
          name = _this$props.name;

      var finalTaggingInfo = _objectSpread(_objectSpread({}, taggingInfo), {}, {
        componentVariation: taggingInfo.componentVariation || 'all',
        componentProduct: taggingInfo.componentProduct || '',
        componentName: taggingInfo.componentName || COMPONENT_NAME,
        eventType: 'focus',
        componentContent: "input-".concat(name)
      });

      (0, _gerenciatdUtils.sendCMSEvent)(finalTaggingInfo);
    });

    _this.state = {
      content: ''
    };
    return _this;
  }

  _createClass(Input, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          id = _this$props2.id,
          name = _this$props2.name,
          cleanButton = _this$props2.cleanButton,
          svgIconProps = _this$props2.svgIconProps,
          theme = _this$props2.theme,
          colorTheme = _this$props2.colorTheme,
          typeField = _this$props2.typeField,
          placeHolder = _this$props2.placeHolder,
          actionInput = _this$props2.actionInput,
          taggingInfo = _this$props2.taggingInfo,
          maxLength = _this$props2.maxLength,
          SvgIconLoader = _this$props2.SvgIconLoader;
      var content = this.state.content;
      var inputThemeCss = this.setCsscolorTheme(colorTheme);
      var inputTypeCss = "e-input e-input--".concat(theme);

      var handleActionInput = function handleActionInput() {
        if (actionInput) {
          actionInput();
        }
      };

      var finalTaggingInfo = _objectSpread(_objectSpread({}, taggingInfo), {}, {
        componentVariation: taggingInfo.componentVariation || 'all',
        componentProduct: taggingInfo.componentProduct || '',
        componentName: taggingInfo.componentName || COMPONENT_NAME,
        componentContent: "input-".concat(name)
      }); // settingUp icon


      var icon2Input = null;

      if (svgIconProps) {
        icon2Input = /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents["default"], {
          className: "e-input__icon",
          onClick: handleActionInput,
          taggingInfo: _objectSpread(_objectSpread({}, finalTaggingInfo), {}, {
            componentContent: "".concat(finalTaggingInfo.componentContent, "-icon")
          }),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SvgIconLoader, _objectSpread(_objectSpread({}, svgIconProps), {}, {
            size: getIconSize(theme)
          }))
        });
      }

      return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "".concat(inputTypeCss, " ").concat(inputThemeCss),
        children: [icon2Input, /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          htmlFor: id,
          className: "e-input__label hide-acc",
          children: placeHolder
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          id: id,
          type: typeField,
          name: name,
          className: "e-input__field",
          placeholder: placeHolder,
          onChange: this.handleChange,
          onFocus: this.handleOnFocus,
          value: content,
          maxLength: maxLength
        }), cleanButton && content && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents["default"], {
          forceExternal: true,
          className: "e-input__clean",
          onClick: this.cleanInput,
          taggingInfo: _objectSpread(_objectSpread({}, finalTaggingInfo), {}, {
            componentContent: "".concat(finalTaggingInfo.componentContent, "-clean-icon")
          }),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SvgIconLoader, {
            id: "Cerrar",
            kind: "S",
            size: 16
          })
        })]
      });
    }
  }]);

  return Input;
}(_react.Component);

Input.propTypes = {
  /* Appearance */

  /**
   * {
   *  "info": "Define el identificador del campo",
   *  "kind": "both",
   *  "beautifulName": "Identificador"
   * }
   */
  id: _propTypes["default"].string.isRequired,

  /**
   * {
   *  "info": "Establece la información que define el icono del input, si lo tiene",
   *  "kind": "both",
   *  "beautifulName": "Icono"
   * }
   */
  svgIconProps: _propTypes["default"].object,

  /**
   * {
   *  "info": "Establece el aspecto del input: linea, con bordes redondeados o con border cuadrados",
   *  "kind": "both",
   *  "beautifulName": "Icono"
   * }
   */
  theme: _propTypes["default"].oneOf([THEME.LINE, THEME.ROUNDED, THEME.BOX]),

  /**
   * {
   *  "info": "Establece el color de fondo del input",
   *  "kind": "both",
   *  "beautifulName": "Color fondo"
   * }
   */
  colorTheme: _propTypes["default"].oneOf([COLOR_THEME.WHITE]),

  /**
   * {
   *  "info": "Función js que se ejecutará cuando ocurre un cambio en el input",
   *  "kind": "both",
   *  "beautifulName": "Funcion onchange"
   * }
   */
  onChange: _propTypes["default"].func,

  /**
   * {
   *  "info": "Tipo de input, sirve para cumplimentar la propiedad type del dom para este elemento, text por defecto",
   *  "kind": "playground",
   *  "beautifulName": "Type"
   * }
   */
  typeField: _propTypes["default"].string,

  /**
   * {
   *  "info": "Nombre del input, sirve para cumplimentar la propiedad name del dom para este elemento",
   *  "kind": "playground",
   *  "beautifulName": "Name"
   * }
   */
  name: _propTypes["default"].string,

  /**
   * {
   *  "info": "Texto que cumplimenta la propiedad placeholdel en el DOM para este elemento y que aparece cuando el input no tiene value",
   *  "kind": "playground",
   *  "beautifulName": "Placeholder"
   * }
   */
  placeHolder: _propTypes["default"].string,

  /**
   * {
   *  "info": "Habilita el botón para limpiar el contenido del input que el propio elemento tiene",
   *  "kind": "playground",
   *  "beautifulName": "Boton clean"
   * }
   */
  cleanButton: _propTypes["default"].bool,

  /**
   * {
   *  "info": "Función js que se ejecutará cuando ocurre un onclick en el input",
   *  "kind": "both",
   *  "beautifulName": "Función onClick"
   * }
   */
  actionInput: _propTypes["default"].func,

  /**
   * {
   *  "info": "Función js que se ejecutará al hacer click en el aspa de borrar",
   *  "kind": "both",
   *  "beautifulName": "Función al borrar"
   * }
   */
  cleanAction: _propTypes["default"].func
};
Input.defaultProps = {
  svgIconProps: null,
  theme: THEME.LINE,
  colorTheme: COLOR_THEME.WHITE,
  onChange: null,
  typeField: 'text',
  name: '',
  placeHolder: '',
  cleanButton: false,
  cleanAction: null,
  actionInput: null
};
var _default = Input;
exports["default"] = _default;

//# sourceMappingURL=index.js.map